export enum CronJobsType {
  PROMOTION = 'PROMOTION',
}
